'use strict'
module.exports = {
  NODE_ENV: '"local"',

	// URLs
	APP_BASEURL: '"http://localhost:8081/"',
	API_BASEURL: '"http://localhost:8082/"',
	APP_REDIRECT_URL: '"https://protopia.co/maintenance"',

	// Auth0
	AUTH0_DOMAIN: '"protopia.auth0.com"',
	AUTH0_CLIENT: '"1TGf1Pg6JJm18KNmQpVN9OBrL2oFjzs3"',
	AUTH0_CALLBACK: '"http://localhost:8081/callback"',

	// APIs
	NLP_API_KEY: '"AIzaSyAuG9BzAULL1S1BCYHCzOjUVraN7EVBXZQ"',

	// Branding
	LOGO_URL: '"https://storage.googleapis.com/protopia/logos/logo_protopia_xs.png"',

	// LinkedIn Integration
	LINKEDIN_CLIENT_ID: '"77lqp1d3zdrmee"',
	LINKEDIN_CLIENT_SECRET: '"80w213F5rvSTL9zM"',
	LINKEDIN_REDIRECT_URI: '"http://localhost:8081/thank-you"',
	LINKEDIN_STATE_KEY: '"PROTOPIA"',

	// App Settings
	DEFAULT_EMAIL: '"team@protopia.co"',
	RANDOM_INTEREST_COUNT: 15,
	ADDITIONAL_PARAM_FRIENDLY_COUNT: 12,
	APP_REDIRECT_TIME: 5000,
	CAPTCHA_SITEKEY: '6LeLKvsqAAAAAHaBUE-R4_iEwPxGgcz7aKcZrFZN',
  	VUE_APP_PROCESS_DASHBOARD_URL:'"http://localhost:8095"',

	// Core-api (recruiting endpoints only — public routes)
	CORE_API_URL: '"http://localhost:8090"',

	// Public base of the recruiting wizard (used only for display in the admin panel;
	// the value stored in Mongo is always the prod URL, enforced by the backend).
	RECRUITING_BASEURL: '"http://localhost:3000"'
}



//////////////////
// WEBPACK FOOTER
// ./config/local.env.js
// module id = Snpf
// module chunks = 1